var map = {
	"./0.svg": 369,
	"./1.svg": 50,
	"./10.svg": 4494,
	"./11.svg": 3670,
	"./12.svg": 3173,
	"./2.svg": 4158,
	"./3.svg": 9380,
	"./4.svg": 9677,
	"./5.svg": 4981,
	"./6.svg": 6090,
	"./7.svg": 9124,
	"./8.svg": 6693,
	"./9.svg": 2356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;